import { API_ENDPOINT } from "@/constants/appConstants";
import { SAVED_JOBS_QUERY_KEY } from "@/lib/queryKeys";
import {
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

import { SavedPageAPIResponseType } from "../saved/types";

export const savedJobAPI = async (
  filterUuid?: string,
  pageParam: number = 1,
  limit: number = 10,
): Promise<SavedPageAPIResponseType> => {
  try {
    const host = window.location.host;
    const response = await fetch(
      `${API_ENDPOINT(host).middleware.jobSaveUnsaveAPI}?${filterUuid ? `categoryField=${filterUuid}&` : ""}start=${(pageParam - 1) * limit}&limit=${limit}`,
      {
        method: "GET",
        credentials: "include",
      },
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching page ${pageParam}: ${response.statusText}`,
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const useSavedJobs = (
  filterStatus: string,
  enableToggle: boolean,
  initialPage: number,
): UseInfiniteQueryResult<{ pages: SavedPageAPIResponseType[] }> => {
  return useInfiniteQuery({
    queryKey: [SAVED_JOBS_QUERY_KEY, filterStatus, initialPage],
    queryFn: ({ pageParam }) => {
      return savedJobAPI(filterStatus, pageParam, 10);
    },
    getNextPageParam: (lastPage, allPages) => {
      const currentPage =
        initialPage == 2 ? allPages.length + 1 : allPages.length;
      return currentPage + 1;
    },
    retry: 1,
    initialPageParam: initialPage,
    enabled: enableToggle,
  });
};
